module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"publishVacancy":"Publish job","restore":"Restore","removeVacancy":"Remove draft","toArchive":"Archive","createCopy":"Copy","vacancyPublished":"Job published","vacancyArchived":"Job archived","vacancyRestored":"Job restored","vacancyCopied":"Job copied","editTest":"Edit test"}}')
  delete Component.options._Ctor
}
